<div class="flex items-center justify-between pb-6">
  <div class="flex items-center gap-2" (click)="onProfileClick.emit();">
    <!--<vw-icon-svg
      iconUrl="{{
          user.profileImage == undefined
            ? '/assets/svg/user.svg'
            : user.profileImage
        }}"
      additionalClasses=""
      width="48"
      height="48"
    ></vw-icon-svg>-->
    <div (click)="handlerClickOnUserGreeting($event)">
      @if (user && user.pseudo) {
        <p class="text-[#7A8581] text-sm" [innerHTML]="'home.header.greeting' | translate: {firstName: user.pseudo}"></p>
      }
      @if (!user || !user.pseudo) {
        <p class="text-[#7A8581] text-sm" [innerHTML]="'home.header.greeting-guest' | translate"></p>
      }
    </div>
  </div>
  <vw-book-icon (click)="handleGuide($event)"
    class="bg-primary-500 text-white text-sm stroke-1 rounded-full p-2 active:bg-primary-800">

  </vw-book-icon>
  <!--<vw-icon-svg
    iconUrl="/assets/svg/bell.svg"
    additionalClasses="cursor-pointer"
    width="40"
    height="40"
  ></vw-icon-svg> -->
</div>
